import {
  UPDATE_SEARCHTDATA_TAIKHOANICLOUD,
} from "./actionTypes";

export const updateDataSearchTaiKhoanIcloud = (data) => ({
  type: UPDATE_SEARCHTDATA_TAIKHOANICLOUD,
  payload: data,
});
